import { getAppModule } from './modules/app'
import searchModule from './modules/search'
import brandsModule from './modules/brands'
import aimeosModule from './modules/aimeos'
import productsModule from './modules/products'
import messagesModule from './modules/messages'
import { WS_CONSTANTS, WS_MODULE } from '@/js/plugins/ws/ws-store-module/index.js'

export const types = {
  APP: 'app',
  BRANDS: 'brands',
  AIMEOS: 'aimeos',
  PRODUCTS: 'products',
  MESSAGES: 'messages',
  SEARCH: 'search',
  [WS_CONSTANTS.MODULE_ID]: WS_CONSTANTS.MODULE_ID,
}

export const getModules = appConfig => {
  return {
    [types.APP]: getAppModule(appConfig),
    [types.SEARCH]: searchModule,
    [types.BRANDS]: brandsModule,
    [types.AIMEOS]: aimeosModule,
    [types.PRODUCTS]: productsModule,
    [types.MESSAGES]: messagesModule,
    [types[WS_CONSTANTS.MODULE_ID]]: WS_MODULE,
  }
}
